module.exports = ".day {\n    border-right: #312783 thin solid;\n    padding: 10px 0;\n    height: -webkit-fit-content;\n    height: -moz-fit-content;\n    height: fit-content;\n}\n\n.day:last-of-type {\n    border: none;\n}\n\n.schedule {\n    overflow-y: scroll;\n    overflow-x: scroll;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/schedule/schedule.component.css
// module id = ./src/app/schedule/schedule.component.css
// module chunks = main